import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsParcelsService} from '../../services/settings-parcels.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'settings-parcels.component.html'
})
export class SettingsParcelsComponent implements OnInit, OnDestroy {

    constructor(public settingsParcelsService: SettingsParcelsService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.settingsParcelsService.getUserRoles();

        this.urlService.onUrlChange
            .pipe(
                tap(
                    () => {
                        this.settingsParcelsService.showDetailedView = false;
                        this.settingsParcelsService.selectedItemData = null;
                    }
                ),
                flatMap(
                    () => this.settingsParcelsService.getCorporationsByQueryParams(true)
                        .pipe(
                            takeUntil(this.urlService.instantOnUrlChange)
                        )
                )
            )
            .subscribe();
        this.urlService.setQueryParams('allSettingsParcels');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsParcelsService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsParcelsService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/settings-parcels.component.ts